const apiUrl = process.env.REACT_APP_MAIN_URL;

export const APIURL = {
  // Administrator
  user_list: apiUrl + '/admin/user/list',
  user_create: apiUrl + '/admin/user/new',
  user_update: apiUrl + '/admin/user/update',
  user_group_list: apiUrl + '/admin/usergroup/list',
  user_group_create: apiUrl + '/admin/usergroup/new',
  user_group_update: apiUrl + '/admin/usergroup/update',
  dokumentasi_list: apiUrl + '/dokumentasi/list',
  dokumentasi_create: apiUrl + '/dokumentasi/create',
  dokumentasi_update: apiUrl + '/dokumentasi/update',
  dokumentasi_delete: apiUrl + '/dokumentasi/delete',
  dokumentasi_download: apiUrl + '/dokumentasi/download',
  program_kerja_list: apiUrl + '/program-kerja/list',
  program_kerja_create: apiUrl + '/program-kerja/create',
  program_kerja_update: apiUrl + '/program-kerja/update',
  syor_sawit_list: apiUrl + '/syor/get-sawit',
  syor_getah_list: apiUrl + '/syor/get-getah',
  syor_sawit_upload: apiUrl + '/syor/upload-sawit',
  syor_getah_upload: apiUrl + '/syor/upload-getah',
  syor_list: apiUrl + '/syor/list',
  syor_delete: apiUrl + '/syor/delete',
  syor_update: apiUrl + '/syor/update',
  syor_download: apiUrl + '/syor/download',
  atd_ph_sawit_upload: apiUrl + '/atd/ph-sawit/upload',
  atd_ph_getah_upload: apiUrl + '/atd/ph-getah/upload',
  atd_ph_get_data: apiUrl + '/atd/ph/get',
  atd_npk_sawit_upload: apiUrl + '/atd/npk-sawit/upload',
  atd_npk_getah_upload: apiUrl + '/atd/npk-getah/upload',
  atd_npk_get_data: apiUrl + '/atd/npk/get',
  atd_list: apiUrl + '/atd/list',
  atd_delete: apiUrl + '/atd/delete',
  atd_update: apiUrl + '/atd/update',
  atd_download: apiUrl + '/atd/download',
  pppls_list: apiUrl + '/pppls/list',
  pppls_update: apiUrl + '/pppls/update',
  pppls_delete: apiUrl + '/pppls/delete',
  pppls_download: apiUrl + '/pppls/download',
  pppls_get_all_kawasan: apiUrl + '/pppls/get-all-kawasan',
  pppls_get_authorization: apiUrl + '/pppls/get-authorization',
  app_auth_unauthorization_list:
    apiUrl + '/pengesahan-aplikasi/unauthorized-user',
  app_auth_authorization_list: apiUrl + '/pengesahan-aplikasi/authorized-user',
  app_auth_create: apiUrl + '/pengesahan-aplikasi/new',
  peserta_dan_lost_list: apiUrl + '/peserta-and-lot/list',
  peserta_dan_lost_delete: apiUrl + '/peserta-and-lot/delete',
  peserta_dan_lot_download: apiUrl + '/peserta-and-lot/download',
  // PIC
  pic_search: apiUrl + '/pic/search',
  pic_list: apiUrl + '/pic/list',
  pic_create: apiUrl + '/pic/create',
  pic_update: apiUrl + '/pic/update',

  // Map
  map_pk_code_get_all: apiUrl + '/mapping/pk-code',
  map_search: apiUrl + '/mapping/search',
  map_upload_raster: apiUrl + '/mapping/upload-raster',
  map_upload_dirian_pokok: apiUrl + '/mapping/upload-dirian-pokok',
  map_upload_raster_progress: apiUrl + '/mapping/progress-raster',
  map_upload_dirian_pokok_progress: apiUrl + '/mapping/progress-dirian',
  map_kewangan_get_data: apiUrl + '/kewangan/get-kewangan',
  map_data_hasil_get: apiUrl + '/data-hasil/get',
  download_report_data_hasil: apiUrl + '/data-hasil/download',
  // Kewangan
  upload_kewangan_pnp: apiUrl + '/kewangan/upload-pnp',
  upload_kewangan_fb: apiUrl + '/kewangan/upload-fb',
  upload_kewangan_jv: apiUrl + '/kewangan/upload-jv',
  upload_kewangan_progress: apiUrl + '/kewangan/progress',
  kewangan_list: apiUrl + '/kewangan/list',
  kewangan_update: apiUrl + '/kewangan/update',
  kewangan_delete: apiUrl + '/kewangan/delete',
  kewangan_download: apiUrl + '/kewangan/download',
};
